import { Autocomplete, OutlinedInput } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import * as React from "react";
import { AddItemToBasketRequest } from "../../../Core/Api/Types/add-item-to-basket-request";

export type TableCellMultipleSelectProps = {
  request: AddItemToBasketRequest;
  options: number[];
  values: number[];
  onChange?: (episodes: number[], externalId: string, titleId: number) => void;
};

const TableCellMultipleSelect = React.forwardRef<any, TableCellMultipleSelectProps>((props, ref) => {
  const { request, options, values, onChange } = props;
  const [selectedEpisodes, setSelectedEpisodes] = React.useState<number[]>(values);

  React.useEffect(() => {
    setSelectedEpisodes(values);
  }, [values]);

  const handleEditEpisodes = (value: number[]) => {
    onChange && onChange(value, request?.externalContractId || "", request?.objectId || 0);
  };

  return (
    <Autocomplete
      ref={ref}
      fullWidth
      options={options}
      defaultValue={options}
      value={selectedEpisodes}
      onChange={(e, value) => handleEditEpisodes(value)}
      popupIcon={<ExpandMoreRoundedIcon />}
      multiple
      getOptionLabel={(option) => String(option)}
      renderInput={(params) => (
        <OutlinedInput {...params.InputProps} inputProps={params.inputProps} required sx={{ width: "100%" }} />
      )}
    />
  );
});

export default TableCellMultipleSelect;
